import { useQuery } from '@tanstack/react-query';
import { tiltify } from '@playlive/tiltify-lib';
import { useCallback } from 'preact/hooks';
import PropTypes from 'prop-types';
import FriendsgivingPollSelector from './friendsgiving-poll-selector.jsx';

const friendsgivingCampaignID = import.meta.env.VITE_FRIENDSGIVING_CAMPAIGN_ID;

FriendsgivingCustomizePolls.propTypes = {
  onPollSelected: PropTypes.func.isRequired,
  pollID: PropTypes.any,
};

export default function FriendsgivingCustomizePolls({
  onPollSelected,
  pollID,
}) {
  const { data: polls, isLoading } = useQuery({
    queryKey: ['friendsgivingCustomizePolls', friendsgivingCampaignID],
    initialData: [],
    queryFn: () => {
      return tiltify.GetPolls(friendsgivingCampaignID);
    },
    refetchInterval: 60000,
  });

  const handlePollSelection = useCallback(
    ({ id }) => {
      onPollSelected(id);
    },
    [onPollSelected]
  );

  return (
    <FriendsgivingPollSelector
      onPollSelected={handlePollSelection}
      polls={polls}
      pollsLoading={isLoading}
      pollID={pollID}
    />
  );
}
